import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

type Props = {
  pdfUrl: string;
  width: number;
  onClick: () => void;
};

export const PdfThumbnail: React.FC<Props> = ({
  pdfUrl,
  width = 150,
  onClick,
}) => {
  return (
    <div
      className="pdf-thumbnail-wrapper"
      onClick={onClick}
      style={{
        width: `${width}px`,
        cursor: 'pointer',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        display: 'inline-block',
      }}
    >
      <Document
        file={pdfUrl}
        loading={
          <div style={{ padding: '16px', textAlign: 'center' }}>Loading...</div>
        }
        error={
          <div style={{ padding: '16px', color: 'red' }}>Failed to load</div>
        }
      >
        <Page
          pageNumber={1}
          width={width}
          renderTextLayer={false}
          renderAnnotationLayer={false}
        />
      </Document>
    </div>
  );
};
